import React, { Fragment, useState, useEffect } from 'react';

import BumpChart from './BumpChart';
// import Dashboard from './Dashboard';

export default () => {
  const [activeSegment, setActiveSegment] = useState(null);

  const onAreaClick = areaKey => {
    const nextActiveSegment = areaKey === activeSegment ? null : areaKey;
    setActiveSegment(nextActiveSegment);
  };

  return (
    <Fragment>
      <BumpChart onAreaClick={onAreaClick} activeSegment={activeSegment} />
      {/*<Dashboard
        activeSegment={activeSegment}
      />*/}
    </Fragment>
  );
};
